var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3057 1.2168H13.9637C15.2332 1.2168 16.2694 2.25307 16.2694 3.5225V15.5173C16.2694 16.7867 15.2332 17.823 13.9637 17.823H2.3057C1.03627 17.823 0 16.7867 0 15.5173V3.49659C0 2.25307 1.03627 1.2168 2.3057 1.2168Z",
    fill: "#4A566E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53886 12.0722L4.11917 8.65247L0 12.7716V13.6266V15.4918C0 16.7613 1.03627 17.7975 2.3057 17.7975H13.9637C15.2332 17.7975 16.2694 16.7613 16.2694 15.4918V13.6266V11.0618L12.4093 7.17578L7.53886 12.0722Z",
    fill: "#00B594"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43515 8.15937C8.23639 8.15937 8.88593 7.50983 8.88593 6.70859C8.88593 5.90735 8.23639 5.25781 7.43515 5.25781C6.63391 5.25781 5.98438 5.90735 5.98438 6.70859C5.98438 7.50983 6.63391 8.15937 7.43515 8.15937Z",
    fill: "#FFCC03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2696 18.7815C18.33 18.7815 20.0002 17.1112 20.0002 15.0509C20.0002 12.9905 18.33 11.3203 16.2696 11.3203C14.2093 11.3203 12.5391 12.9905 12.5391 15.0509C12.5391 17.1112 14.2093 18.7815 16.2696 18.7815Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8107 16.8129C16.8107 17.1238 16.5776 17.357 16.2667 17.357C15.9558 17.357 15.7227 17.1238 15.7227 16.8129V13.3155C15.7227 13.0306 15.9558 12.7715 16.2667 12.7715C16.5517 12.7715 16.8107 13.0046 16.8107 13.3155V16.8129Z",
    fill: "#00B594"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6567 17.201C16.4495 17.4083 16.1127 17.4083 15.9054 17.201C15.6982 16.9938 15.6982 16.657 15.9054 16.4497L17.149 15.2062C17.3562 14.999 17.693 14.999 17.9003 15.2062C18.1075 15.4135 18.1075 15.7503 17.9003 15.9575L16.6567 17.201Z",
    fill: "#00B594"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6566 16.4497C16.8639 16.657 16.8639 16.9938 16.6566 17.201C16.4494 17.4083 16.1126 17.4083 15.9053 17.201L14.6359 15.9575C14.4287 15.7503 14.4287 15.4135 14.6359 15.2062C14.8432 14.999 15.18 14.999 15.3872 15.2062L16.6566 16.4497Z",
    fill: "#00B594"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.56f62c12ada21499550b1cc2c8d2db34.svg";
export { ForwardRef as ReactComponent };